import React from "react";
import { Fab, Badge } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const FloatingCartButton = ({ cartCount, clickCallBack, cartRef }) => {

    return (
        <Fab
            ref={cartRef}
             color="primary"
            sx={{ position: "fixed", bottom: 20, right: 20, zIndex: 1}}
            onClick={clickCallBack && clickCallBack}
        >
            <Badge badgeContent={cartCount} color="error" showZero>
                <ShoppingCartIcon />
            </Badge>
        </Fab>
    );
};

export default FloatingCartButton;